module.exports = __webpack_public_path__ + "static/media/homepage_atf_3_mo_en.ab5decc2.png";